<template>
  <div class="mt-1" v-if="canVerb(resource, 'update')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in visibleFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span
                :class="{ 'hidden-filter-x': isFilterRequired(name) }"
                tabindex="0"
              >
                <span @click="resetSingleSidebarFilter(name)" title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countVisibleFilters > 0">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countVisibleFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle:sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countVisibleFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">
          {{ computedFilterTitle }}
        </span>
      </b-button-group>
      <export-options
        :exportUrl="exportUrl"
        :repository="repository"
        :resource="resource"
        :tableRef="$refs[tableRef]"
        :filter="filter"
        :options="[
          {
            code: 'LISTSOSP',
            label: null,
            formats: ['csv', 'pdf'],
          },
          {
            code: 'TOTASOSP',
            label: null,
            formats: ['csv', 'pdf'],
          },
        ]"
      ></export-options>
      <b-button
        v-if="
          canVerb(resource, 'update') &&
          $store.state.auth.settings.attributables.LISAPAY === 'Y' &&
          $store.state.auth.settings.attributables.LPAYZCH === 'Y'
        "
        class="btn--smaller btn--transparent"
        type="button"
        variant="secondary"
        size="sm"
        @click="customOpenSyncroModal($event.target)"
        title="Recupera da Syncro"
        >Recupera da Syncro
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        class="btn--smaller btn--transparent"
        title="Chiusura massiva selezionati"
        @click="openMassReducedModal()"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Chiusura massiva selezionati
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        class="btn--smaller btn--transparent"
        title="Chiusura massiva di tutti i sospesi"
        :disabled="!deferredCount"
        @click="openMassReduceAll()"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Chiusura massiva di tutti i sospesi
      </b-button>
    </actions-toolbar>

    <b-sidebar
      id="sidebar-1"
      :title="computedFilterTitle"
      :backdrop="true"
      width="50dvw"
      shadow
      right
      :visible="open_filter"
      :data-open="open_filter"
      @change="onSidebarFilterChange"
    >
      <b-form @submit.prevent="onSearch(filterName)">
        <div class="filter">
          <div class="filter-item" data-cols="3">
            <base-select
              name="deferred"
              label="Mostra Sospesi"
              :options="deferred"
              v-model="filter.byDeferred"
            />
            <base-input
              name="Contraente"
              v-model="filter.byRegistry.title"
              type="text"
              label="Contraente"
              placeholder="Inserisci un nominativo"
            />
            <base-input
              name="Polizza"
              label="Polizza"
              v-model="filter.byInsurancePolicy.number"
              placeholder="Inserisci un numero polizza"
            />
          </div>
          <div class="filter-item" data-cols="2">
            <div>
              <base-select
                name="salesman_id"
                label="Produttori"
                :options="salesmen_select"
                v-model="filter.byBroker.id"
                :multiple="true"
                :taggable="salesmen_taggable"
                :closeOnSelect="false"
                :defaultHtmlMultipleSelect="true"
                @changeTaggable="changeTaggable"
              >
                <template #advanced-actions>
                  <b-button
                    :pressed.sync="myToggle"
                    variant="light"
                    class="btn--x-smaller btn--smaller btn--transparent"
                    @click="
                      myToggle ? selectAllSalesmen() : deselectAllSalesmen()
                    "
                    >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                  <b-button
                    :pressed.sync="myTogglePO"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="
                      myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                    "
                    >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
                  </b-button>
                </template>
              </base-select>
            </div>
            <base-select
              name="insurer"
              label="Compagnia"
              :options="companies"
              v-model="filter.byInsurer.id"
              :multiple="true"
              :taggable="true"
              :closeOnSelect="false"
              :defaultHtmlMultipleSelect="true"
            />
          </div>
          <div class="filter-item">
            <base-select
              name="code"
              label="Modalità rec. sospeso"
              :options="treasuries"
              v-model="filter.byReduced.treasury_deferred"
              :multiple="true"
            />
          </div>
          <div class="filter-item" data-type="registry-group">
            <div>
              <b-button-toolbar>
                <b-button-group>
                  <base-input
                    :class="{
                      'filter-item-inner-wrapped': true,
                    }"
                    name="Gruppo Anagrafico"
                    label="Gruppo Anagrafico"
                    v-model="form.inpt_label_group"
                    :readonly="true"
                  />
                  <b-button
                    class="btn-quick btn--light"
                    size="sm"
                    text="Button"
                    variant="lisaweb"
                    title="Cerca gruppo anagrafico"
                    @click="openQuickSearchGroup"
                  >
                    <!-- <b-icon icon="search"></b-icon> -->
                    <base-icon name="search" width="14" height="14"></base-icon>
                  </b-button>
                  <b-button
                    v-if="form.inpt_label_group"
                    class="btn--light btn--alert"
                    size="sm"
                    text="Button"
                    variant="lisaweb"
                    @click="resetGroupId"
                    title="Elimina gruppo anagrafico"
                  >
                    <!-- <base-icon name="trash" width="22" height="22"></base-icon> -->
                    <base-icon name="trash" width="22" height="22"></base-icon>
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </div>
          </div>
          <quick-search-group-modal
            ref="quickSearchGroup"
            @input="handleGroupModalInput"
          ></quick-search-group-modal>
          <div class="filter-item" data-type="registry-group-info">
            <div class="details-card-wrapper" v-if="extra_group_full_info">
              <b-card>
                <div
                  slot="header"
                  class="d-flex justify-content-between align-items-center"
                >
                  <p class="mb-0 d-inline-block align-middle">
                    <strong>Informazioni gruppo anagrafico selezionato</strong>
                  </p>
                </div>
                <div
                  class="custom-grid-wrapper"
                  v-html="extra_group_full_info"
                ></div>
              </b-card>
            </div>
          </div>
          <div class="filter-item" data-cols="2">
            <base-datepicker
              name="aperto_dal"
              label="Periodo di registrazione a cassa del sospeso dal"
              v-model="filter.byCalendar.from"
            />
            <base-datepicker
              name="aperto_al"
              label="Periodo di registrazione a cassa del sospeso al"
              v-model="filter.byCalendar.to"
            />
          </div>
          <div class="filter-item" data-cols="2">
            <base-datepicker
              name="incasso_successivo"
              label="Periodo di recupero del sospeso dal"
              v-model="filter.byReduced.after_deferred"
            />
            <base-datepicker
              name="incasso_precedente"
              label="Periodo di recupero del sospeso al"
              v-model="filter.byReduced.before_deferred"
            />
          </div>
          <h3 class="inner-filter-title mt-5">Filtri aggiuntivi</h3>
          <div class="filter-item" data-cols="2">
            <base-input
              name="Note"
              label="Note"
              v-model="filter.byCustom.description.value"
              placeholder="Inserisci una nota"
            />
            <base-select
              name="code"
              label="Delega"
              :options="delega"
              v-model="filter.byInsurancePolicy.sharing_type"
            />
          </div>
          <div v-show="customFilters.length > 0">
            <p>Attributi personalizzati</p>
            <b-row v-for="(element, index) in customFilters" :key="index">
              <custom-filter
                v-model="filter.byAttribute[element.key]"
                :element="element"
              />
            </b-row>
          </div>
        </div>
        <div class="actions-filter-sidebar-wrapper">
          <b-button
            type="submit"
            variant="lisaweb"
            size="sm"
            v-b-toggle:sidebar-1
            >Cerca
          </b-button>
          <b-button
            class="btn--transparent btn-reset"
            type="button"
            size="sm"
            @click="onClearFilter(filterName)"
            >Reset
          </b-button>
        </div>
      </b-form>
    </b-sidebar>
    <book-entries-deferred
      :fields="fields"
      :repository="repository"
      :filterOn="{
        byRelations: [
          'byVariousAccounting',
          'byRegistry',
          'byRegistryGroup',
          'byInsurer',
          'byBroker',
          'byInsurancePolicy',
          'byTask',
        ],
      }"
      :resource="resource"
      :filterName="filterName"
      @manualFetch="manualFetch"
      :performedSearch="computePerformedSearch"
      :filterCount="countVisibleFilters"
      :ref="tableRef"
      :onlyActions="['infomodal']"
      :hasChecksButtonGroup="false"
      hasChecks
      descending
      sortField="book_date"
      :total_deferred="total_deferred"
      :total_collected="total_collected"
      @onMassReduced="openMassReducedModal"
    ></book-entries-deferred>
    <mass-reduced-modal
      @save="onMassReducedSave"
      :grandtotaldeferred="grandtotaldeferred"
      :mode="massReduceMode"
      :total="massReduceTotal"
      :total-amount="massReduceAmount"
    ></mass-reduced-modal>
    <recupera-da-syncro-modal
      v-if="canVerb(resource, 'update')"
      @fetch="forcedFetch"
      type="deferred"
    >
    </recupera-da-syncro-modal>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import RecuperaDaSyncroModal from "@/components/modals/recuperaDaSyncroModal";
import BaseIcon from "@/components/BaseIcon";
// import QuickSearchPolicyModal from "@/components/modals/quickSearchPolicy";
import QuickSearchGroupModal from "@/components/modals/quickSearchGroup";
import massReducedModal from "@/components/modals/massReducedModal";
import BookEntriesDeferred from "@/components/tables/BookEntriesDeferred";
import ExportOptions from "@/components/ExportOptions";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseInput from "@/components/form/BaseInput";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters, mapActions } from "vuex";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import { toInfoData /* , toRelationString  */ } from "@/utils/transforms";
import FormMixin from "@/mixins/FormMixin";
import moment from "moment";

moment.locale("it");
import { prepareFilterQueryString } from "@/utils/forms";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";
import StorageGetterMixin from "../../../mixins/StorageGetterMixin";

export default {
  mixins: [
    CustomFiltersMixin,
    StorageGetterMixin,
    FormMixin,
    SidebarFilterMixin,
  ],
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      filterName: "filterAccountingDeferred",
      resource: "book_entries",
      context: "book_entries_deferred",
      repository: "book_entry",
      tableRef: "AccountingDeferredTableRef",
      notes: [],
      companies: [],
      treasuries: [],
      salesmen: [],
      myTogglePO: false,
      myToggle: false,
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      delega: [
        { value: "0", text: "Delega Nostra" },
        { value: "1", text: "Delega Altrui" },
      ],
      salesmen_taggable: true,
      registry_group_data: null,
      insurance_policy_data: null,
      group_data: null,
      activeFilters: {},
      performedSearch: false,
      grandtotaldeferred: null,
      massReduceMode: "selection",
      massReduceFilter: "",
      massReduceTotal: 0,
      massReduceAmount: null,
      deferredCount: 0,
      extra_group_full_info: null,
      total_deferred: {
        isLoading: true,
        total: null,
      },
      total_collected: {
        isLoading: true,
        total: null,
      },
      form: {
        inpt_label_policy: "",
        inpt_label_group: "",
        quick_value: "",
      },
      fields: [
        {
          key: "check",
          label: "",
          sortable: false,
          thClass: "check",
          class: "check",
        },
        {
          key: "recovery_status",
          label: this.getDictionary("Stato"),
          sortable: false,
        },
        {
          key: "book_date",
          label: this.getDictionary("book_date", "book_entry"),
          sortable: true,
          sortKey: "book_date",
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "last_deferred",
          label: this.getDictionary("Ultimo Recupero"),
          sortable: true,
          sortKey: "byView.max",
        },
        {
          key: "insurer.formatted_title",
          label: this.getDictionary("insurer_id", "book_entry"),
          sortable: true,
          sortKey: "byInsurer.title",
        },
        {
          key: "branch",
          label: this.getDictionary("title", "risk_branch"),
        },
        {
          key: "product",
          label: this.getDictionary("insurance_risk"),
          sortable: true,
          sortKey: "byInsuranceRisk.title",
        },
        {
          key: "insurance_policy_number",
          label: this.getDictionary("insurance_policy_number", "book_entry"),
          sortable: true,
          sortKey: "byInsurancePolicy.number",
        },
        {
          key: "registry",
          label: this.getDictionary("registry", "book_entry"),
          sortable: true,
          sortKey: "byRegistry.title",
        },
        {
          key: "broker",
          label: this.getDictionary("broker", "book_entry"),
          sortable: true,
          sortKey: "byBroker.BUID",
        },
        {
          key: "note_counter",
          label: this.getDictionary("Note"),
        },
        {
          key: "primary_group",
          label: this.getDictionary("primary_group"),
          sortable: false,
          sortKey: "byRegistryGroup.code",
        },
        {
          key: "gross",
          label: this.getDictionary("gross", "book_entry"),
          sortable: true,
          formatter: (value) => toLocaleCurrency(value),
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "deferred",
          label: this.getDictionary("Da incassare"),
          formatter: (value) => toLocaleCurrency(value),
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      deferred: [
        { value: "yes", text: "Aperti e parzialmente aperti" },
        { value: "no", text: "Chiusi e parzialmente recuperati" },
        { value: "reduced", text: "Parzialmente aperti" },
      ],
      coassicurazioni: [
        { value: "Y", text: "SI" },
        { value: "N", text: "NO" },
      ],
    };
  },
  components: {
    BaseIcon,
    // ButtonGroupTable,
    ExportOptions,
    BaseSelect,
    BaseDatepicker,
    BookEntriesDeferred,
    BaseInput,
    // QuickSearchPolicyModal,
    QuickSearchGroupModal,
    massReducedModal,
    RecuperaDaSyncroModal,
  },
  methods: {
    toInfoData,
    forcedFetch(policy_number) {
      // if (this.isCollapseOpen === true) {
      //   this.$root.$emit("bv::toggle::collapse", "deferredCollapse");
      // }
      if (policy_number) {
        this.onClearFilter(this.filterName);
        this.filter.byInsurancePolicy.number = policy_number;
      }
      // this.$refs[this.tableRef].fetch();
      this.$root.$emit("bv::hide::collapse", "deferredCollapse");
      this.onSearch(this.filterName);
    },
    customOpenSyncroModal(target) {
      console.log("target", target);
      this.$bvModal.show("recuperaDaSyncroModal");
    },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllSalesmen() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllSalesmen() {
      this.filter.byBroker.id = [];
      this.salesman_id = null;
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    prepareFilterQueryString,
    initFilter() {
      let init = {
        byAttribute: {
          aperto_dal: null,
          aperto_al: null,
          ape_inc: null,
          sospesi_al: null,
        },
        byView: "deferred",
        byRegistry: {
          id: null,
          title: null,
        },
        byInsurancePolicy: {
          id: null,
          number: null,
          shating_type: null,
        },
        byInsurer: {
          id: null,
        },
        byBroker: {
          id: null,
        },
        byRegistryGroup: {
          code: null,
        },
        byCustom: {
          description: {
            value: null,
            likewise: 4,
            filter: "byTask",
          },
        },
        byDeferred: "yes",
        byCalendar: {
          from: null,
          to: null,
        },
        byReduced: {
          after_deferred: null,
          before_deferred: null,
          treasury_deferred: null,
        },
        coassicurazione: null,
      };
      return init;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
        if (Array.isArray(table.selectedRows)) {
          table.selectedRows = [];
        }
      }
      this.grandtotaldeferred = null;
      this.total_deferred = { isLoading: false, total: null };
      this.total_collected = { isLoading: false, total: null };
      this.open_filter = true;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    storeMassReduced(form) {
      if (this.$refs["AccountingDeferredTableRef"].selectedRows.length) {
        // Elementi selezionati
        let items = this.$refs["AccountingDeferredTableRef"].items;
        let selectedItems = items.filter(
          (item) => item.check && this.totalDeferred(item) !== 0,
        );
        if (selectedItems.every((item) => item.book_date <= form.book_date)) {
          // Payload
          let payload = {
            treasury_id: null,
            detail_date: form.book_date,
            gross: null,
            book_entry_id: null,
          };

          // Promise
          let storedeferred = [];
          // let deferred_pivot = [];

          const allItemPromises = Object.values(selectedItems).map((item) => {
            storedeferred = [];

            // Forma di pagamento
            payload.gross = this.totalDeferred(item);
            payload.book_entry_id = item.id;
            payload.treasury_id = form.treasury_id;
            let detail = this.store("entry_detail", payload);
            storedeferred.push(detail);

            // Sospeso
            payload.gross = -parseFloat(this.totalDeferred(item).toFixed(2));
            payload.treasury_id = this.getTreasuries()([]).find(
              (treasury) => treasury.code === "SS",
            ).value;
            let deferred = this.store("entry_detail", payload);
            storedeferred.push(deferred);

            // Pivot
            return Promise.all(storedeferred)
              .then((response) => {
                //Store Pivot, counter
                let pivotPayload = { entry_detail: {} };
                let deferredId = response.find(
                  (entry_detail) =>
                    entry_detail.data.data.treasury.code === "SS",
                ).data.data.id;
                response
                  .filter(
                    (entry_detail) =>
                      entry_detail.data.data.treasury.code !== "SS",
                  )
                  .forEach(
                    (entry_detail) =>
                      (pivotPayload.entry_detail[entry_detail.data.data.id] =
                        {}),
                  );

                // deferred_pivot = this.storeEntryDetail(
                //   deferredId,
                //   "entry_detail",
                //   pivotPayload
                // );
                return this.storeEntryDetail(
                  deferredId,
                  "entry_detail",
                  pivotPayload,
                );
              })
              .catch((error) => {
                let errMsg = this.$getErrorMessage(error);
                this.$showSnackbar({
                  preset: "error",
                  text: `${errMsg}`,
                });
              });
          });
          Promise.all(allItemPromises)
            .then(() => {
              this.$showSnackbar({
                preset: "success",
                text: `Azione Completata: Chiusura Massiva Completata`,
              });
              this.$refs["AccountingDeferredTableRef"].fetch();
              this.$bvModal.hide(`massReducedModal`);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
        } else {
          this.$showSnackbar({
            preset: "error",
            text: "Non è possibile procedere per la presenza di sospesi con data reg. superiore alla data di chiusura",
          });
        }
      } else {
        this.$showSnackbar({
          preset: "error",
          text: "Devi selezionare almeno una riga",
        });
      }
    },
    storeEntryDetail(deferredEntryDetailId, relation, payload) {
      const Repo = RepositoryFactory.get("entry_detail");
      return Repo.pivot_store(deferredEntryDetailId, relation, payload);
    },
    openMassReducedModal() {
      this.massReduceMode = "selection";
      this.grandtotaldeferred =
        this.$refs["AccountingDeferredTableRef"].grandTotalDeferred;
      this.$bvModal.show("massReducedModal");
    },
    openMassReduceAll() {
      const table = this.$refs[this.tableRef];
      this.massReduceMode = "all";
      this.massReduceFilter = table ? table.buildDeferredFilterQueryString() : "";
      this.massReduceTotal = table ? table.totalItems : 0;
      this.massReduceAmount =
        this.total_deferred.total != null
          ? toLocaleCurrency(this.total_deferred.total)
          : null;
      this.$bvModal.show("massReducedModal");
    },
    onMassReducedSave(form) {
      if (this.massReduceMode === "all") {
        this.storeMassReduceAll(form);
      } else {
        this.storeMassReduced(form);
      }
    },
    storeMassReduceAll(form) {
      const payload = {
        treasury_id: form.treasury_id,
        detail_date: form.book_date,
        filter: this.massReduceFilter,
        type: "deferred",
      };
      this.$bvModal.hide("massReducedModal");
      this.$root.$emit("massReduceStart", {
        payload,
        total: this.massReduceTotal,
        context: {
          entity: "sospesi",
          routeName: "module.CONT.SOSP",
          reloadEvent: "reloadDeferred",
          goLabel: "Vai ai sospesi",
        },
      });
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create` });
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    isFilterRequired(name) {
      const defaultFilters = this.initFilter();
      if (name in defaultFilters) {
        return (
          JSON.stringify(this.visibleFilters[name]) ===
          JSON.stringify(defaultFilters[name])
        );
      }
      return false;
    },
    processQueryString(query) {
      // Match `byReduced[after_deferred]` and `byReduced[before_deferred]`
      const afterDeferredMatch = query.match(
        /byReduced\[after_deferred\]=([^&]+)/,
      );
      const beforeDeferredMatch = query.match(
        /byReduced\[before_deferred\]=([^&]+)/,
      );

      // Extract the values if they exist
      const afterDeferredValue = afterDeferredMatch
        ? afterDeferredMatch[1]
        : null;
      const beforeDeferredValue = beforeDeferredMatch
        ? beforeDeferredMatch[1]
        : null;

      // If both values are present
      if (afterDeferredValue && beforeDeferredValue) {
        // Combine values into `byReduced[between_deferred]`
        const combinedValue = `byReduced[between_deferred]=${afterDeferredValue},${beforeDeferredValue}`;

        // Remove the old parameters
        query = query
          .replace(/byReduced\[after_deferred\]=[^&]+&?/, "")
          .replace(/byReduced\[before_deferred\]=[^&]+&?/, "");

        // Ensure no trailing `&` and append the new parameter
        query = query.replace(/&$/, ""); // Clean up trailing `&` if any
        query = `${query}&${combinedValue}`;
      }

      return query;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      let extra_info = this.extra_group_full_info;
      this.saveFilterExtraGroupByName({ name, extra_info });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      // quicksearch
      criteria = {};
      ["quickSearchPolicy", "quickSearchGroup"].forEach((element) => {
        criteria[element] = {
          label: "",
          formLabel: "",
          data: null,
          formData: null,
        };
      });
      criteria.quickSearchPolicy.label = this.form.inpt_label_policy;
      criteria.quickSearchPolicy.formLabel = "form.inpt_label_policy";
      criteria.quickSearchPolicy.data = this.insurance_policy_data;
      criteria.quickSearchPolicy.formData = "insurance_policy_data";
      criteria.quickSearchGroup.label = this.form.inpt_label_group;
      criteria.quickSearchGroup.formLabel = "form.inpt_label_group";
      criteria.quickSearchGroup.data = this.group_data;
      criteria.quickSearchGroup.formData = "group_data";
      this.saveQuickSearchByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;

      const qs = this.prepareFilterQueryString(this.filter);
      this.total_deferred = {
        isLoading: true,
        total: null,
      };
      this.total_collected = {
        isLoading: true,
        total: null,
      };

      this.$refs[this.tableRef]
        .fetch()
        .then(() => {
          this.deferredCount = this.$refs[this.tableRef].totalItems || 0;
          this.loadDeferredTotal(qs);
          this.loadCollectedTotal(qs);
        })
        .catch((error) => {
          console.error(error);
          this.total_deferred.isLoading = false;
          this.total_collected.isLoading = false;
        });
    },
    loadDeferredTotal(qs) {
      const Repo = RepositoryFactory.get("book_entry");
      const qs_processed = this.processQueryString(qs);
      this.isLoading = true;
      Repo.deferred_total(qs_processed)
        .then((response) => {
          this.total_deferred.total = response.data.deferred_total;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.total_deferred.isLoading = false;
          this.isLoading = false;
        });
    },
    loadCollectedTotal(qs) {
      const Repo = RepositoryFactory.get("book_entry");
      const qs_processed = this.processQueryString(qs);

      Repo.collected_total(qs_processed)
        .then((response) => {
          this.total_collected.total = response.data.collected_total;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.total_collected.isLoading = false;
        });
    },
    onClearFilter(name) {
      this.resetPolicyId();
      this.filter.byRegistry.title = null;
      this.resetGroupId();
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removeQuickSearchByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.$refs[this.tableRef].sortBy = "book_date";
      this.$refs[this.tableRef].sortDesc = true;
      // this.onSearch(name);
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    handlePolicyModalInput(value) {
      this.form.quick_value = value.id;
      this.filter.byInsurancePolicy.id = value.id;
      this.form.inpt_label_policy = value.number;
      this.insurance_policy_data = value;
      this.$bvModal.hide("quickSearchPolicyModal");
    },
    openQuickSearchPolicy() {
      this.form.quick_value = null;
      this.$bvModal.show("quickSearchPolicyModal");
    },
    resetPolicyId() {
      this.insurance_policy_data = null;
      this.form.inpt_label_policy = null;
      this.filter.byInsurancePolicy.id = null;
    },
    handleGroupModalInput(value) {
      this.filter.byRegistryGroup.code = value.code;
      this.group_data = value;
      this.form.inpt_label_group = this.toInfoData(
        this.group_data,
        "registry_group",
      );
      this.extra_group_full_info = this.toInfoData(
        this.group_data,
        "registry_group_full",
        null,
        "",
      );
      this.$bvModal.hide("quickSearchGroupModal");
    },
    openQuickSearchGroup() {
      this.filter.byRegistryGroup.code = null;
      this.$bvModal.show("quickSearchGroupModal");
    },
    resetGroupId() {
      this.group_data = null;
      this.form.inpt_label_group = null;
      this.filter.byRegistryGroup.code = null;
      this.extra_group_full_info = null;
    },
    totalDeferred(item) {
      return parseFloat(
        item.entry_details
          .filter((el) => el.treasury.code == "SS")
          .reduce(function (acc, obj) {
            return acc + obj.gross;
          }, 0)
          .toFixed(2),
      );
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      saveFilterExtraGroupByName: "saveExtraGroupByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("quicksearch", {
      saveQuickSearchByName: "saveByName",
      removeQuickSearchByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getTreasuries: "treasuries",
    }),
  },
  computed: {
    visibleFilters() {
      const others = { ...this.activeFilters };
      delete others.byView;
      return others;
    },
    countVisibleFilters() {
      return Object.keys(this.visibleFilters).length;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countVisibleFilters ? ` (${this.countVisibleFilters})` : ""
      }`;
    },
  },
  // beforeDestroy() {
  //   this.onClearFilter(this.filterName);
  //   /* Fix navigazione all'interno del modulo CONT */
  //   const filterName = "filterRegistryGroup";
  //   this.removeFilterByName(filterName);
  //   this.removePaginationByName(filterName);
  //   this.removeSortByName(filterName);
  // },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_select = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
  },
  mounted() {
    // this.filter.byDeferred = this.deferred[0].value;  // USARE INIT FILTER !!!!
    if (this.$refs[this.tableRef]) {
      const qs = this.prepareFilterQueryString(this.filter);
      this.loadDeferredTotal(qs);
    }
    this.companies = this.getInsurers();
    this.salesmen = this.getSalesmen();
    this.treasuries = this.getTreasuries()(["SS"]);
    this.onCollapseState = (collapseId, isJustShown) => {
      if (collapseId === "deferredCollapse") {
        this.isCollapseOpen = isJustShown;
      }
    };
    this.$root.$on("bv::collapse::state", this.onCollapseState);
    this.onReloadDeferred = () => this.onSearch(this.filterName);
    this.$root.$on("reloadDeferred", this.onReloadDeferred);
  },
  beforeDestroy() {
    this.$root.$off("bv::collapse::state", this.onCollapseState);
    this.$root.$off("reloadDeferred", this.onReloadDeferred);
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("councils"))
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {
            console.info(`background data "${path}councils" fetched correctly`);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("provinces"))
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {
            console.info(
              `background data "${path}provinces" fetched correctly`,
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            console.info(
              `background data "${path}countries" fetched correctly`,
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          console.log("All promises went through correctly");
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
  },
};
</script>
<style scoped></style>
